import React, { useState } from 'react';
import { Textarea } from '@mantine/core';
import '../styles/components/button.css';

const TapButton = ({
  children,
  width,
  height,
  padding,
  backgroundColor,
  color,
  className = '',
  onClick,
  onChange,
  checked = false, // 외부에서 상태 전달 받음
  hasTextarea = false,
  showReasonText = false,
  reasonText = '사유작성',
  textareaProps = {},
  isChecked: externalIsChecked,
  ...props
}) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleClick = () => {
    const newChecked = !isChecked; // 외부 상태 기준으로 토글
    setIsChecked(newChecked);
    if (onChange) onChange(newChecked);
    if (onClick) onClick();
  };

  const handleTextareaChange = e => {
    if (textareaProps.onChange) {
      textareaProps.onChange(e);
    }
  };

  return (
    <div className="tap-button-container">
      <button
        className={`tap-button ${isChecked ? 'checked' : ''} ${className}`}
        onClick={handleClick}
        style={{ width, height, padding, backgroundColor, color }}
        {...Object.fromEntries(
          Object.entries(props).filter(
            ([key]) => ['id', 'type', 'disabled', 'tabIndex', 'aria-label', 'data-testid'].includes(key) || key.startsWith('data-') || key.startsWith('aria-')
          )
        )}
      >
        <div className={`custom-checkbox ${isChecked ? 'checked' : ''}`}></div>
        <span className="tap-text">{children}</span>
        {showReasonText && !isChecked && <span className="reason-text">{reasonText}</span>}
      </button>

      {hasTextarea && !isChecked && (
        <div className="tap-textarea-container">
          <Textarea
            placeholder="미완료 사유를 작성해주세요"
            rows={3}
            {...textareaProps}
            onChange={handleTextareaChange}
            styles={{
              input: {
                borderRadius: '10px',
                border: '1px solid #F9F9F9',
                background: '#F9F9F9',
                fontSize: '16px',
                color: '#333',
                height: '80px',
              },
            }}
          />
        </div>
      )}
    </div>
  );
};

export default TapButton;
